import React, { useState, useEffect } from "react";

const Footer = () => {
  const [footerData, setFooterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const response = await fetch(
          "https://ecommerce-product-05-19692c57dcd1.herokuapp.com/api/footer-section"
        );
        const result = await response.json();

        if (!result.success) {
          throw new Error(result.message || "Failed to fetch data");
        }

        setFooterData(result.data);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching footer data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchFooterData();
  }, []);

  if (loading) {
    return <></>;
  }

  if (error) {
    return (
      <div className="footer section-padding">
        <div className="container">
          <div className="alert alert-danger" role="alert">
            Error loading footer: {error}
          </div>
        </div>
      </div>
    );
  }

  if (!footerData || !footerData.isActive) {
    return null; // Don't render if section is inactive
  }

  return (
    <div>
      <div className="footer section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-sm-6 col-xs-12">
              <div className="single_footer">
                <a href={footerData.logo.link}>
                  <img src={footerData.logo.url} alt={footerData.logo.alt} />
                </a>
                <p>{footerData.description}</p>
              </div>
            </div>
            {/*- END COL */}
            {footerData.sections &&
              footerData.sections.map((section) => (
                <div key={section.id} className="col-lg-3 col-sm-6 col-xs-1">
                  <div className="single_footer">
                    <h4>{section.title}</h4>
                    <ul>
                      {section.links &&
                        section.links.map((link) => (
                          <li key={link.id}>
                            <a href={link.url}>{link.text}</a>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              ))}
            {/*- END COL */}
          </div>
          {/*- END ROW */}
          <div className="row fc">
            <div className="col-lg-12">
              <div className="footer_copyright">
                <p>{footerData.copyright.text}</p>
              </div>
            </div>
            {/* Footer Menu is deactivated and not rendered */}
          </div>
        </div>
        {/*- END CONTAINER */}
      </div>
    </div>
  );
};

export default Footer;
